export default {
  tabs: {
    private: 'Moje',
    public: 'Publiczne',
    nearby: 'Pobliskie',
    followed: 'Obserwuje',
    daily: 'Feed',
    all: 'Wszystkie',
    myHubs: 'Moje',
    exploreHubs: 'Eksploruj'
  },
  comments: {
    placeholder: 'Napisz komentarz...',
    add: 'Wyślij',
    postComment: 'Dodaj komentarz',
    reply: 'Odpowiedz',
    cancel: 'Anuluj',
  },
  buttons: {
    edit: 'Edytuj',
    delete: 'Usuń',
    finish: 'Zakończ',
    publish: 'Opublikuj',
    cancel: 'Anuluj',
    chat: 'Wiadomości',
    leave: 'Opuść',
    uploadGpx: 'Prześlij GPX',
    confirmGpx: 'Zapisz GPX',
    downloadGpx: 'Pobierz GPX',
    moveToContext: 'Przenieś do kontekstu',
  },
  accordions: {
    addSocialMedia: 'Dodaj Social Media'
  },
  freaks: {
    visibility: {
      public: 'Publiczny',
      private: 'Prywatny',
      daily: 'Dzienny',
      weekly: 'Tygodniowy',
      monthly: 'Miesięczny',
      yearly: 'Roczny',
      campaign: 'Kampania',
      promotion: 'Promowanie',
      freak_hub: 'Freakowisko'
    },
    status: {
      inProgress: 'W trakcie',
      finished: 'Zakończony',
      planned: 'Zaplanowany',
      canceled: 'Anulowany'
    },
    operations: {
      start: 'Rozpocznij',
      join: 'Dołącz',
      requested: 'Wysłano'
    },
    participate: {
      pending: 'W trakcie',
      approved: 'Zaakceptowane',
      declined: 'Odrzucone',
      requestJoin: 'Wysłane'
    },
    emptyList: 'Brak freaków do wyświetlenia.',
    emptyListDaily: 'Brak feed do wyświetlenia. Stwórz swój Feed ! ;)',
    emptyListFollowed: 'Brak Freaków do wyświetlenia',
    deleted: 'Freak został usunięty ;(',
    unauthorized: 'Musisz zaakceptować zaproszenie by wyświetlić tego Freak',
    favourited: 'Polubione',
    loading: 'Ładowanie Freaków'
  },
  profile: {
    editMessage: 'Edytuj',
    freaks: 'Freaków',
    followers: 'Obserwujących',
    following: 'Obserwuje',
    points: 'Freak Punktów',
    verified: 'freak-land.com',
    prizeHistory: 'Moje Nagrody',
    topFeeds: 'Top Feeds',
    freakFeeds: 'Aktywny/a w Freak Feeds',
    freakHubs: 'Aktywny/a w Freakowiskach',
    mainContext: 'Główny kontekst',
    ambassador: 'Ambasador Kontekstu',
    ambassadorGifts: 'Nagrody Ambasadora',
    ambassadorGiftsSubline: 'Zaglądaj regularnie — z czasem dodajemy nowe korzyści i fizyczne prezenty dla aktywnych ambasadorów.',
    howToGain: 'Jak zdobyć',
    giftTypeRecognition: 'Widoczność',
    giftTypePhysical: 'Fizyczny prezent',
    giftTypeDigital: 'Cyfrowy',
    giftTypeDiscount: 'Zniżka',
    giftTypeExperience: 'Doświadczenie',
    giftValue: 'Wartość',
  },
  articles: {
    my: 'Moje Artykuły',
    favourited: 'Polubione Artykuły',
    emptyList: 'Brak artukułów do wyświetlenia.'
  },
  freakItems: {
    title: 'Freak Things',
    add: 'Dodaj Freak Thing',
    empty: 'Brak przedmiotów',
    name: 'Nazwa',
    category: 'Kategoria',
    customCategory: 'Własna kategoria…',
    brand: 'Marka',
    model: 'Model',
    year: 'Rok',
    purchaseDate: 'Data zakupu',
    description: 'Opis',
    specs: 'Specyfikacja',
    addSpec: 'Dodaj parametr',
    public: 'Widoczne na profilu',
    save: 'Zapisz',
    delete: 'Usuń',
    deleteConfirm: 'Usunąć ten przedmiot?',
    usageStats: 'Użycie',
    activities: 'Aktywności',
    distance: 'Dystans',
    time: 'Czas',
    linkedFreaks: 'Użyto podczas',
    gearUsed: 'Użyty sprzęt',
  },
  contextPicker: {
    customize: 'Dostosuj',
    customizeTitle: 'Wybierz widoczne konteksty',
    customizeHint: 'W przełączniku widać tylko zaznaczone konteksty. Możesz to zmienić w każdej chwili.',
    showAll: 'Pokaż wszystkie',
    save: 'Zapisz',
    cancel: 'Anuluj',
    selectAtLeastOne: 'Zaznacz co najmniej jeden kontekst',
  },
  settings: {
    title: 'Ustawienia',
    logout: 'Wyloguj',
    shakeIt: 'Shake It!',
    forceReload: 'Pobierz najnowszą wersję',
    version: 'Wersja',
    update: 'Zapisz',
    bio: 'Napisz coś o sobie',
    bioLabel: 'Bio',
    socialLinksLabel: 'Media społecznościowe',
    userImageLabel: 'Zdjęcie profilowe',
    backgroundImageLabel: 'Zdjęcie tła',
    modeLabel: 'Tryb',
    modeLabelDescription: 'Zmień tryb na ciemny.',
    languageLabel: 'Język',
    languageLabelDescription: 'Wybierz język.',
    languagePolish: 'Polski',
    languageEnglish: 'Angielski',
    contextLabel: 'Domyślny Kontekst',
    settings: 'Ustawienia',
    notifications: 'Ustawienia notyfikacji',
    customNotifications: 'Własne powiadomienia',
    customNotificationsDescription: 'Powiadomienia o nowych aktywnościach w pobliżu Twoich miejsc',
    mushroomRadarNotification: '🍄 Grzyby radar',
    fishingNearbyNotification: 'Radar wędkarski',
    contextWof: 'Wild Off Road',
    contextBike: 'Kolarstwo',
    contextFishing: 'Wędkarstwo',
    contextTrip: 'Podróże',
    contextFit: 'Fit',
    contextRunning: 'Bieganie',
    contextDogs: 'Zwierzaki',
    contextGames: 'Gry',
    contextBooks: 'Książki',
    contextFood: 'Kuchnia',
    contextShopping: 'Promki',
    contextTech: 'Technologie',
    contextMotorization: 'Motoryzacja',
    contextGardening: 'Ogrodnictwo',
    contextMusic: 'Muzyka',
    contextSport: 'Sport',
    contextWinterSports: 'Sporty Zimowe',
    contextHorseRiding: 'Jazda Konna',
    contextMovies: 'Filmy',
    contextSeries: 'Seriale',
    contextSkateboard: 'Deskorolka',
    contextInlineSkate: 'Rolki',
    contextScooter: 'Hulajnoga',
    contextBmx: 'Bmx',
    contextMushroom: 'Na Grzyby',
    contextNordicWalking: 'Nordic Walking',
    switchThemeDark: 'Zmień na tryb ciemny',
    switchThemeLight: 'Zmień na tryb jasny',
    theme: 'Motyw'
  },
  modals: {
    confirmation: {
      areYouSure: 'Czy napewno chcesz wykonać ?',
      actionUndone: 'Nie można będzie cofnąć tej operacji.',
      confirm: 'Potwierdź',
      decline: 'Anuluj',
      emailHasBeenSent: 'Email potwierdzający został wysłany.',
      ok: 'OK'
    },
    tooManyRequests: {
      niceTry: 'Niezła próba 😉 Niestety, ale przekroczyłeś dzienny limit. Wróć do nas jutro, albo...',
      youHaveReachedYourLimit: 'Przekroczyłeś dzienny limit. Wróć do nas jutro, albo...',
      register: 'Zarejestruj się za darmo, aby dostać pełny dostęp 🥳',
      buyMeACoffee: 'Jeśli podoba Ci się nasza aplikacja 🙃',
      newsletter: 'Zapisz się na Newsletter'
    },
    moveContext: {
      title: 'Przenieś do innego kontekstu',
      hint: 'Freak pojawi się w wybranym kontekście.'
    }
  },
  editor: {
    placeholders: {
      postTitle: 'Tytuł',
      postContent: 'Treść'
    },
    save: 'Zapisz'
  },
  freakEditor: {
    placeholders: {
      freakTitle: 'Tytuł',
      freakContent: 'Treść'
    },
    defaults: {
      body: 'Mój nowy Freak!'
    },
    add: 'Dodaj',
    save: 'Zapisz',
    isPrivateLabel: 'Zasięg Freaka',
    private: 'Prywatny',
    public: 'Publiczny',
    freakVisibility: 'Ustawienia',
    createPlace: 'Stwórz Prywatne Miejsce',
    showInPlaces: 'Pokaż w Miejscach',
    createFreaks: 'Stwórz Freaky!',
    createTrack: 'Stwórz trasę!',
    requestTrack: 'Poproś o nagrywanie trasy',
    trackRequested: 'Wysłano prośbę o nagrywanie trasy',
    freakRouteMobileAppNeeded: 'Zainstaluj aplikację mobilną📱lub na zegarek⌚i twórz Freak trasy.',
    freakyMobileAppNeeded: 'Zainstaluj aplikację mobilną📱lub na zegarek⌚i twórz Freaksy.',
    deleteRoute: 'Usuń trasę',
    createTitle: 'Utwórz freaka',
    editTitle: 'Edytuj freaka',
    post: 'Opublikuj',
    update: 'Zapisz',
    titlePlaceholder: 'Nadaj freakowi tytuł',
    bodyPlaceholder: 'Co się dzieje w terenie?',
    titleRequired: 'Dodaj tytuł, aby opublikować freaka',
    addToFreak: 'Dodaj do freaka',
    photo: 'Zdjęcie',
    camera: 'Aparat',
    tagPeople: 'Oznacz osoby',
    location: 'Lokalizacja',
    hub: 'FreakHub',
    route: 'Trasa (GPX)',
    dateTime: 'Data i godzina',
    links: 'Linki',
    audienceTitle: 'Kto może zobaczyć freaka?',
    publicDescription: 'Każdy we Freakland',
    privateDescription: 'Tylko Ty i oznaczone osoby',
    with: 'z',
    in: 'w',
    at: 'w miejscu',
    now: 'Teraz',
    uploading: 'Wysyłanie zdjęć…',
    searchLocation: 'Szukaj adresu',
    myPlaces: 'Wybierz z moich miejsc',
    currentLocation: 'Bieżąca lokalizacja',
    linksTitle: 'Dodaj linki',
    done: 'Gotowe',
    remove: 'Usuń',
    removePhotoConfirm: 'Usunąć to zdjęcie z freaka?',
    removeRouteConfirm: 'Usunąć tę trasę z freaka?',
    discardTitle: 'Odrzucić tego freaka?',
    discardMessage: 'Twoje zmiany zostaną utracone.',
    discard: 'Odrzuć',
    keepEditing: 'Edytuj dalej',
    changeDate: 'Zmień datę',
    changeTime: 'Zmień godzinę',
    create: 'Utwórz freaka',
    edit: 'Edytuj freaka',
    photosTitle: 'Dodaj zdjęcia'
  },
  campaignEditor: {
    placeholders: {
      freakTitle: 'Tytuł',
      freakContent: 'Treść'
    },
    add: 'Dodaj',
    save: 'Zapisz',
    isPrivateLabel: 'Prywatna Kampania',
    freakVisibility: 'Ustawienia'
  },
  freakPlacesEditor: {
    placeholders: {
      title: 'Nazwa',
      content: 'Opis'
    },
    isPrivateLabel: "Prywatna miejscówka",
    private: 'Prywatne',
    public: 'Publiczne',
    createTitle: 'Dodaj miejsce',
    editTitle: 'Edytuj miejsce',
    save: 'Dodaj',
    update: 'Zapisz',
    namePlaceholder: 'Nazwij swoje miejsce',
    descriptionPlaceholder: 'Co wyróżnia to miejsce?',
    required: 'Dodaj nazwę, krótki opis i lokalizację, aby zapisać miejsce',
    privateInfo: 'Prywatne miejsce · widzisz je tylko Ty i dodane osoby',
    addPhotos: 'Dodaj zdjęcia',
    addToPlace: 'Dodaj do miejsca',
    addPeople: 'Dodaj osoby',
    location: 'Lokalizacja',
    pickLocation: 'Gdzie to jest? Dotknij, aby wybrać lokalizację',
    useCurrentLocation: 'Użyj mojej bieżącej lokalizacji',
    links: 'Linki',
    linksTitle: 'Dodaj linki',
    website: 'Strona www',
    youtube: 'Kanał YouTube',
    facebook: 'Strona na Facebooku',
    instagram: 'Profil na Instagramie',
    discardTitle: 'Odrzucić to miejsce?',
    create: 'Dodaj miejsce',
    edit: 'Edytuj miejsce'
  },
  freakCampaigns: {
    noCampaigns: 'Brak aktywnych kampanii reklamowych.',
    contact: 'Chcesz stworzyć kampanię?',
    contactButton: 'Skontaktuj się z nami!',
    winPrice: 'Przejdź do Freak Shake!',
    everyDayWin: 'Codziennie coś do wygrania!',
    requestCampaign: 'Wysłano prośbę o kontakt',
    close: 'Zamknij'
  },
  freakView: {
    filter: 'Filtruj:',
    search: 'Wyszukaj...',
    yourLocation: 'Twoja lokalizacja',
    sortBy: 'Sortuj:',
    likes: 'Polubienia',
    status: 'Status',
    planned: 'Zaplanowany',
    canceled: 'Anulowany',
    finished: 'Zakończony',
    inProgress: 'W trakcie',
    date: 'Dacie utworzenia',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    asc: 'Rosnąco',
    desc: 'Malejąco',
    none: 'Brak',
    participant: 'Uczestnik/Autor'
  },
  freakPreview: {
    messages: {
      plannedTo: 'Zaplanowany na',
      finishedAt: 'Zakończony',
      alreadyRunning: 'W trakcie'
    },
    copy: {
      copyLink: 'Skopiuj link',
      copied: 'Skopiowano!',
      failed: 'Nieudało się skopiować'
    },
    share: {
      checkoutThis: 'Sprawdź to !'
    },
    requestTrackAccess: {
      button: '',
      dialogTitle: 'Nagrywanie tras GPS — Wczesny dostęp',
      dialogBody: 'Nagrywanie trasy GPS w czasie rzeczywistym jest obecnie dostępne tylko dla wybranych użytkowników. Aby poprosić o dostęp, wyślij e-mail ze swoim zarejestrowanym adresem e-mail.',
      emailSubject: 'Prośba o dostęp do tras',
      emailCta: 'Wyślij prośbę',
      close: 'Zamknij',
    },
  },
  moderation: {
    pending: 'Czeka na akceptację administratora',
    rejected: 'Odrzucone przez administratora',
  },
  freakActions: {
    organizer: 'Organizator',
    going: {
      one: 'Ekipa: {count}',
      few: 'Ekipa: {count}',
      many: 'Ekipa: {count}',
    },
    joinRequests: {
      one: '{count} prośba o dołączenie',
      few: '{count} prośby o dołączenie',
      many: '{count} próśb o dołączenie',
    },
    ownerTitle: 'Organizujesz tego freaka',
    ownerHintPlanned: 'Wystartuj, gdy ekipa będzie gotowa.',
    ownerHintInProgress: 'Trwa! Zakończ, gdy wszyscy wrócą.',
    ownerHintFinished: 'Ten freak jest zakończony. Dobra robota!',
    ownerHintCanceled: 'Ten freak został anulowany.',
    ownerHintFeed: 'Twój feed jest widoczny dla wszystkich w tym kontekście.',
    participantTitle: 'Jesteś w ekipie!',
    participantHint: 'Pisz z ekipą, dodawaj zdjęcia i trasy poniżej.',
    requestedTitle: 'Prośba wysłana',
    requestedHint: 'Organizator wkrótce ją sprawdzi. Damy Ci znać.',
    invitedTitle: 'Masz zaproszenie',
    invitedHint: 'Zaakceptuj zaproszenie w powiadomieniach, aby dołączyć.',
    declinedTitle: 'Prośba odrzucona',
    declinedHint: 'Organizator tym razem nie zaakceptował Twojej prośby.',
    guestTitle: 'Chcesz dołączyć?',
    guestHint: 'Wyślij prośbę — organizator decyduje, kto jest w ekipie.',
    closedHint: 'Ten freak nie przyjmuje już nowych uczestników.',
    joinCta: 'Dołącz do freaka',
    start: 'Wystartuj freaka',
    finish: 'Zakończ freaka',
    more: 'Więcej',
    comments: 'Komentarze',
    confirm: {
      start: {
        title: 'Wystartować freaka?',
        message: 'Uczestnicy zobaczą, że freak trwa.',
      },
      finish: {
        title: 'Zakończyć freaka?',
        message: 'Zapiszemy czas zakończenia i zamkniemy freaka.',
      },
      cancel: {
        title: 'Anulować freaka?',
        message: 'Uczestnicy zobaczą, że freak został anulowany.',
      },
      delete: {
        title: 'Usunąć freaka?',
        message: 'Zdjęcia, komentarze i trasy zostaną usunięte. Tej operacji nie można cofnąć.',
      },
      leave: {
        title: 'Opuścić freaka?',
        message: 'Aby wrócić, trzeba będzie ponownie poprosić o dołączenie.',
      },
      keep: 'Nie teraz',
    },
  },
  freakDetails: {
    localization: 'Lokalizacja',
    localizationDescription: 'Miejsce wydarzenia',
    plannedTo: 'Planowany start:',
    startedAt: 'Czas startu:',
    finishedAt: 'Czas zakończenia:',
    duration: 'Czas trwania:',
    checkOnGoogleMaps: 'Sprawdź na Google Maps',
    noParticipants: 'Brak uczestników...',
    participants: 'Uczestnicy',
    participantsDescription: 'Freaki biorące udział w wydarzeniu',
    description: 'Opis',
    linkToArticle: 'Link do strony',
    information: 'Informacje',
    informationDescription: 'Informacje o wydarzeniu',
    socialMedia: 'Social Media',
    socialMediaDescription: 'Youtube, Facebook, Instagram',
    likes: 'Polubienia',
    route: 'Trasa',
    activity: 'Statystyki'
  },
  freakParticipants: {
    remove: 'Usuń'
  },
  freakSelect: {
    placeholders: {
      selectParticipants: 'Wybierz uczestników',
      searchParticipants: 'Wpisz nazwę użytkownika',
      selectPlace: 'Wybierz miejsce',
      searchPlace: 'Wpisz nazwę miejsca',
    }
  },
  freakHubSelect: {
    placeholders: {
      selectFreakHub: 'Wybierz Freakowisko',
      searchFreakHub: 'Wpisz nazwę Freakowiska',
    }
  },
  freakLocalization: {
    placeholders: {
      search: 'Wybierz lokalizację...'
    },
    yourLocalization: 'Twoja lokalizacja',
    distance: 'W odległości od Ciebie',
    all: 'Wszystkie',
    markerIsDraggable: 'Zamkij to okno i przenieś pinezke',
    clickToDragMarker: 'Kliknij tu, żeby edytować pinezke',
    filter: {
      header: 'Filtruj',
      status: 'Status',
      participant: 'Uczestnik',
      localization: 'Lokalizacja'
    },
    sort: {
      header: 'Sortuj',
      likes: 'Polubione',
      date: 'Data'
    }
  },
  freakCampaign: {
    participantsDescription: 'Freaki biorące udział w kampanii',
    cooperation: 'Współpraca',
    cooperationBody: 'Chcesz tworzyć własne Kampanie?',
    contact: 'Napisz do nas',
    requestContact: 'lub zamów kontakt a my odezwiemy się do Ciebie'
  },
  notifications: {
    types: {
      invitation: 'Zaproszenie',
      info: 'Informacja',
      requestJoin: 'Prośba o dołączenie'
    },
    emptyList: 'Nie masz żadnych powiadomień',
    accept: 'Zaakceptuj',
    decline: 'Odrzuć',
    show: 'Wyświetl',
    delete: 'Usuń',
    denied: 'Notyfikacje zablokowane.',
    settings: 'Ustawienia notyfikacji'
  },
  giphy: {
    placeholders: {
      search: 'Wyszukaj GIFy'
    }
  },
  uploadFiles: {
    upload: 'Wybierz pliki (png, jpg, jpeg, heic). Limit 10mb.',
    notSupportedFileType: 'Nie wspierany format pliku',
    somethingWentWrong: 'Coś poszło nie tak, spróbuj jeszcze raz',
    tooLargeFile: 'Zbyt duży plik. Limit 10mb.',
    locationChoice: {
      title: 'Lokalizacja zdjęcia',
      message: 'Wybierz lokalizację, która zostanie przypisana do zdjęcia',
      useExif: 'Użyj lokalizacji ze zdjęcia',
      useCurrent: 'Użyj bieżącej lokalizacji',
      withoutLocation: 'Bez lokalizacji',
    },
  },
  datePicker: {
    placeholders: {
      select: 'Wybierz datę'
    }
  },
  login: {
    needAccount: 'Nie masz konta?',
    tryUsFirst: 'lub wypróbuj nas wcześniej 🙃',
    addToHomeScreen: 'Dodaj do ekranu głównego',
    signIn: 'Logowanie',
    password: 'Hasło',
    forgotPassword: 'Zresetuj hasło',
    buttons: {
      signIn: 'Zaloguj się'
    }
  },
  resetPassword: {
    label: 'Zresetuj hasło',
    sendEmail: 'Wyślij Email'
  },
  setupPassword: {
    setupNew: 'Ustaw nowe hasło',
    placeholders: {
      password: 'Hasło',
      confirmPassword: 'Potwierdź hasło'
    },
    confirm: 'Potwierdź'
  },
  register: {
    signUp: 'Zarejestruj się',
    haveAnAccount: 'Masz konto?',
    emailSent: 'Email z linkiem do potwierdzenia konta został wysłany.',
    termsOfService: 'Rejestrując się w celu utworzenia konta akceptuję',
    termsOfServiceTitle: 'Warunki korzystania z usługi',
    termsOfServiceAnd: 'i',
    privacyPolicy: 'Politykę Prywatności',
    placeholders: {
      username: 'Nazwa użytkownika',
      password: 'Hasło',
      birthDate: 'Data urodzenia'
    },
    defaultContext: 'Freak',
    birthDateHint: 'Freakland jest dla osób w wieku 16 lat i starszych. Datę urodzenia wykorzystujemy wyłącznie do sprawdzenia wieku.'
  },
  readMoreComponent: {
    more: 'Więcej...',
    less: 'Mniej...'
  },
  linksPlace: {
    placeholders: {
      add: 'Dodaj link tutaj...',
      invalidLink: 'Nieprawidłowy link',
    }
  },
  linksYoutube: {
    placeholders: {
      add: 'Dodaj link YouTube...',
      addFeed: 'Dodaj kanał YouTube...',
      invalidLink: 'Nieprawidłowy link',
      invalidFeed: 'Nieprawidłowy kanał'
    }
  },
  linksFacebook: {
    placeholders: {
      add: 'Wklej link Facebook...',
      invalidLink: 'Nieprawidłowy link',
      groupMessenger: 'Dodaj link do Messengera Twojej Grupy...'
    }
  },
  linksInstagram: {
    placeholders: {
      add: 'Wklej link Instagram...',
      invalidLink: 'Nieprawidłowy link'
    }
  },
  linksX: {
    placeholders: {
      add: 'Wklej link X...',
      invalidLink: 'Nieprawidłowy link'
    }
  },
  bottomNavigation: {
    freaks: 'Freak',
    notifications: 'Powiadomienia',
    messages: 'Chat',
    places: 'Miejsca',
    campaigns: 'Kampanie',
    record: 'Freak'
  },
  leftNavigation: {
    add: 'Dodaj',
    freaks: 'Freak',
    notifications: 'Powiadomienia',
    messages: 'Chat',
    places: 'Miejsca',
    hub: 'Freakowisko',
    campaigns: 'Kampanie',
    topFreaks: 'Top Freaks',
    theFreaks: 'The Freaks',
    context: 'Kontekst',
    filters: 'Filtry',
    profile: 'Profil'
  },
  freakPlaces: {
    navigate: 'Sprawdź na:',
    noFishingPlaces: 'Brak łowisk — dodaj miejsce, aby zobaczyć prognozę, połowy i pogodę.',
    filterPlaceholder: 'Filtruj miejsca po nazwie…',
    sharePlace: 'Udostępnij miejsce',
    copyLink: 'Skopiuj link',
    copied: 'Skopiowano!',
    copyFailed: 'Nie udało się skopiować',
    details: 'Szczegóły',
    edit: 'Edytuj',
    sendForPublic: 'Wyślij, żeby zrobić publiczne',
    waitingForApproval: 'Oczekuje na akceptacje',
    delete: 'Usuń',
    freaksFromThisPlace: 'Z tego miejsca:',
    noFreaksFromThisPlace: 'Brak Freaków z tego miejsca.',
    restrictedView: 'Zarejestruj się żeby uzyskać pełny dostęp!',
    restrictedView2: 'Odblokuj możliwości po utworzeniu konta.',
    restrictedView3: 'Masz już konto?',
    registerToGetFullAccess: 'Dołącz',
    fishing_pzw: 'PZW',
    fishing_commercial: 'Komercyjny',
    fishing_white_card_only: 'Tylko biała karta',
    wof_motocross: 'Off-road',
    winter_sports_ski_resort: 'Stok Narciarski',
    winter_sports_snowpark: 'Snowpark',
    bike_green: 'Trasy zielone',
    bike_blue: 'Trasy niebieskie',
    bike_red: 'Trasy czerwone',
    bike_black: 'Trasy czarne',
    loadingFreakPlaces: 'Ładowanie Miejsc...'
  },
  contextSwipeableDrawerComponent: {
    title: 'Kontekst',
    close: 'Zamknij',
    resetAllFilters: 'Zresetuj Filtry'
  },
  filterSwipeableDrawerComponent: {
    title: 'Ustawienia'
  },
  snackbar: {
    open: 'Otwórz',
    denied: 'Notyfikacje zablokowane.'
  },
  emailConfirmed: {
    message: 'Email potwierdzony.',
    buttonMessage: 'Zaloguj'
  },
  reportAbuse: {
    report: 'Zgłoś nadużycie',
    spam: 'Spam lub Scam',
    hate: 'Zawiera mowę nienawiści lub atakuje osobę',
    violence: 'Agresywne zachowania',
    nudity: 'Nagość, pornografia lub treści o charakterze jednoznacznie seksualnym',
    duplicate: 'Zduplikowane, fałszywe lub błędnie sklasyfikowane treści',
    harassment: "Nękanie lub szkodliwe zachowanie",
    copyright: "Prawa autorskie",
    misinformation: "Dezinformacja",
    other: "Inne"
  },
  topFreaks: {
    title: "Top Freak'ów",
    points: "Freak punktów"
  },
  topFeeds: {
    title: "Top Feeds",
  },
  followedBy: {
    title: 'Twoi Obserwujący',
    noBio: 'Brak bio'
  },
  following: {
    title: 'Obeserwujesz',
    noBio: 'Brak bio'
  },
  userBlock: {
    reportUser: "Zgłoś użytkownika",
    reportUserDescription: "Wybierz powód zgłoszenia tego użytkownika",
    block: "Zablokuj użytkownika",
    unblock: "Odblokuj",
    blockConfirmTitle: "Zablokować {username}?",
    blockConfirmMessage: "Nie będziecie widzieć swoich freaków, komentarzy ani Blastów i przestaniecie się obserwować. Ta osoba nie dostanie powiadomienia.",
    blockConfirm: "Zablokuj",
    cancel: "Anuluj",
    send: "Wyślij",
    blocked: "Zablokowałeś {username}",
    blockedInfo: "Treści tej osoby są ukryte. Odblokuj, aby znów je widzieć.",
    blockedToast: "Użytkownik zablokowany",
    unblockedToast: "Użytkownik odblokowany",
    reportedToast: "Zgłoszenie wysłane — dziękujemy",
    error: "Coś poszło nie tak",
    empty: "Nikogo nie zablokowałeś",
    blockedUsers: "Zablokowani użytkownicy",
    blockedUsersDescription: "Osoby, które zablokowałeś — tutaj je odblokujesz",
  },
  profileFavorites: {
    follow: 'Obserwuj',
    unfollow: 'Przestań obserwować'
  },
  usersList: {
    title: 'Użytkownicy'
  },
  errors: {
    error401Message: '401 Przejdź do Freak.',
    error404Message: 'Przejdź do Freak.',
  },
  shortsCreator: {
    retake: 'Zrób nowy',
    save: 'Zapisz'
  },
  freakLocalizationTracker: {
    liveMinutesAgo: 'Na żywo · {count} min temu',
    you: 'Ty',
    live: 'na żywo',
    distance: 'Dystans:',
    duration: 'Czas:',
    movingTime: 'Czas:',
    speed: 'Prędkość',
    maxSpeed: 'Prędkość Maks.:',
    avgSpeed: 'Średnia Prędkość:',
    altitude: 'Wysokości:',
    maxAltitude: 'Max Wysokości:',
    calories: 'Calories:',
    hydration: 'Hydration:',
    avgHeartRate: 'Średnie tętno:',
    maxHeartRate: 'Maks. tętno:'
  },
  freakTrackerView: {
    resume: 'Wznów',
    start: 'Start',
    pause: 'Pauza',
    finish: 'Zakończ',
    clear: 'Wyczyść',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    pauseConfirm: 'Twój postęp zostanie zachowany.',
    finishConfirm: 'Trasa zostanie zapisana.',
    clearConfirm: 'Wszystkie nagrane dane zostaną utracone.',
    discard: 'Odrzuć',
    discardTitle: 'Odrzucić ten ślad?',
    finishTitle: 'Zakończyć nagrywanie?',
    time: 'Czas',
    distance: 'Dystans',
    speed: 'Prędkość',
    pace: 'Tempo',
    avgSpeed: 'Śr. prędkość',
    avgPace: 'Śr. tempo',
    maxSpeed: 'Maks. prędkość',
    elevation: 'Maks. wysokość',
    recording: 'Nagrywanie',
    paused: 'Pauza',
    gpsSearching: 'Szukam GPS…',
    gpsGood: 'GPS gotowy',
    gpsWeak: 'Słaby GPS',
    showStats: 'Pokaż wszystkie statystyki',
    showMap: 'Pokaż mapę',
    recenter: 'Wyśrodkuj na mnie',
    back: 'Wróć',
  },
  freakPlacesList: {
    fromThisPlace: 'Freaków z tego miejsca:',
    filter: 'Filtruj',
  },
  cometChat: {
    CHATS: 'Czaty',
    USERS: 'Użytkownicy',
    DELETE: 'Tak',
    CANCEL: 'Anuluj',
    DELETE_CONVERSATION: 'Usunięcie konwersacji',
    WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: 'Czy chcesz usunąć tą konwersacje?'
  },
  feeds: {
    title: "Feeds",
    subscribe: 'Subskrybuj'
  },
  shake: {
    shakeToWin: 'Wstrząśnij by wygrać!',
    win: 'Twoja nagroda to:',
    onlyOnePerDay: 'Masz tylko jeden shake dziennie, następny shake w ciągu:',
    permissions: 'Proszę o udzielenie pozwolenia na wykrywanie ruchu urządzenia.',
    loading: 'Przeliczanie nagrody... Wróć proszę za chwilę lub przeładuj stronę',
    visitShop: 'Odwiedź nasz Freak Sklep!'
  },
  hubs: {
    view: 'Zobacz',
    join: 'Dołącz',
    emptyList: 'Brak Freakowisk',
    privateView: 'Dostępne tylko dla członków Freakowiska',
    editMessage: 'Edytuj',
    deleteMessage: 'Usuń'
  },
  hubDetails: {
    freaksCount: 'Freak postów',
    usersCount: 'Użytkowników',
    createdAt: 'Utworzona',
    join: 'Dołącz'
  },
  hubEditor: {
    defaults: {
      title: 'Freakowisko',
      body: 'Nowe Freakowisko!'
    },
    placeholders: {
      title: 'Tytuł',
      content: 'Opis'
    },
    save: 'Zapisz',
    createTitle: 'Utwórz FreakHub',
    editTitle: 'Edytuj FreakHub',
    update: 'Zapisz',
    namePlaceholder: 'Nazwij swój hub',
    descriptionPlaceholder: 'O czym jest ten hub? Kto powinien dołączyć?',
    required: 'Dodaj nazwę i opis, aby utworzyć hub',
    publicInfo: 'Publiczny hub · każdy we Freakland może go znaleźć',
    addCover: 'Dodaj zdjęcie w tle',
    changeCover: 'Zmień zdjęcie w tle',
    addPhoto: 'Zdjęcie huba',
    addToHub: 'Dodaj do huba',
    inviteMembers: 'Zaproś członków',
    members: 'Członkowie',
    discardTitle: 'Odrzucić ten hub?',
    createAction: 'Utwórz'
  },
  hubUsers: {
    title: 'Użytkownicy w'
  },
  placesSearch: {
    placeholder: 'Szukaj miejsc…',
    filters: 'Filtry',
    nearMe: 'W pobliżu',
    mapArea: 'Ten obszar mapy',
    withPhotos: 'Ze zdjęciami',
    radius: 'Promień',
    clearAll: 'Wyczyść',
    resultsZero: 'Brak miejsc',
    resultsOne: '1 miejsce',
    resultsFew: '{0} miejsca',
    resultsMany: '{0} miejsc',
    noResultsTitle: 'Nie znaleziono miejsc',
    noResultsHint: 'Spróbuj innej frazy lub poluzuj filtry.',
    clearFilters: 'Wyczyść filtry',
    locationDenied: 'Zezwól na dostęp do lokalizacji, aby szukać miejsc w pobliżu.',
    freaksHere: 'Freaki: {0}',
    close: 'Zamknij wyniki',
    loadMore: 'Pokaż więcej',
  },
  algoliaSearch: {
    search: 'Szukaj...'
  },
  freakPlacesTabs: {
    info: 'Informacje',
    prediction: 'Prognoza',
    catches: 'Połowy',
    weather: 'Pogoda',
  },
  weather: {
    title: 'Pogoda',
    noData: 'Brak danych pogodowych',
    weekForecast: 'Prognoza 7-dniowa',
    today: 'Dziś',
    temperature: 'Temperatura',
    water: 'Woda',
    precipitation: 'Opady',
    wind: 'Wiatr',
    pressure: 'Ciśnienie',
    cloudCover: 'Zachmurzenie',
    hourlyForecast: 'Prognoza godzinowa',
  },
  fishingPrediction: {
    title: 'Prognoza połowu',
    noData: 'Brak danych prognozy',
    noDataForPlace: 'Brak prognozy dla tego miejsca',
    todayForecast: 'Dzisiejsza prognoza',
    weekForecast: '7-dniowa prognoza',
    activityHigh: 'Wysoka',
    activityMedium: 'Średnia',
    activityLow: 'Niska',
    fallbackNotice: 'Predykcje bazują na warunkach pogodowych — brak historii połowów. Dodaj min. 5 połowów, aby aktywować model AI.',
    possibleFish: 'Możliwe ryby',
    saveNewCatch: 'Zapisz nowy połów',
    saveCatch: 'Zapisz połów',
    bestSpecies: 'Najlepszy gatunek',
    activity: 'aktywność',
  },
  feedback: {
    title: 'Wyślij opinię',
    subtitle: 'Chętnie poznamy Twoje zdanie — zgłoszenia błędów, pomysły lub ogólne uwagi.',
    contextLabel: 'Czego to dotyczy?',
    contextOverall: 'Ogólnie / cała aplikacja',
    messageLabel: 'Twoja wiadomość',
    emailLabel: 'Twój e-mail (opcjonalnie, jeśli chcesz odpowiedzi)',
    submit: 'Wyślij',
    successMessage: 'Dzięki — Twoja opinia została wysłana!',
    errorMessage: 'Coś poszło nie tak podczas wysyłania opinii. Spróbuj ponownie.',
    captchaError: 'Potwierdź, że nie jesteś robotem',
  },
  mushroomRadar: {
    button: 'Radar grzybowy',
    title: 'Grzyby — radar',
    loading: 'Wczytywanie danych grzybowych…',
    error: 'Nie udało się wczytać danych grzybowych.',
    empty: 'Brak danych grzybowych w tej chwili.',
    source: 'Źródło: grzyby.pl',
    close: 'Zamknij',
    updated: 'Zaktualizowano',
    legendTitle: 'Natężenie występowania grzybów',
    legendLow: 'mało',
    legendHigh: 'dużo',
    legendNote: 'Kolory pochodzą wprost z radaru grzyby.pl.',
    legendNoData: 'brak danych',
  },
  fishingRadar: {
    button: 'Radar wędkarski',
    title: 'Wędkarstwo — radar',
    loading: 'Wczytywanie prognozy brań…',
    error: 'Nie udało się wczytać radaru wędkarskiego.',
    empty: 'Brak danych radaru w tej chwili.',
    close: 'Zamknij',
    updated: 'Zaktualizowano',
    legendTitle: 'Prognozowana aktywność brań',
    legendLow: 'słabe',
    legendHigh: 'doskonałe',
    legendNote: 'Wskaźnik szacunkowy na podstawie pogody i fazy księżyca — nie jest gwarancją brań.',
    legendNoData: 'brak danych',
  },
  quickCreate: {
    buttonA11y: 'Szybkie tworzenie: nagraj trasę lub dodaj blast',
    title: 'Szybki start',
    subtitle: 'Wybierz, co chcesz uchwycić — freaka utworzymy za Ciebie.',
    close: 'Zamknij',
    track: {
      title: 'Nagraj trasę',
      hint: 'Włącz GPS i jedź. Zapis do nowego freaka.',
      defaultTitle: 'Trasa',
      locked: 'Jeszcze niedostępne dla Ciebie',
    },
    blast: {
      title: 'Dodaj blast',
      hint: 'Krótkie wideo do 60 s w nowym freaku.',
      defaultTitle: 'Blast',
    },
    freakLabel: 'Twój freak',
    titlePlaceholder: 'Nazwij go (opcjonalnie)',
    private: 'Prywatny',
    here: 'Obecna lokalizacja',
    now: 'Start teraz',
    creating: 'Tworzę Twojego freaka…',
    fullEditor: 'Wolisz pełny edytor? Utwórz freaka',
    locationNeeded: 'Zezwól na lokalizację, aby przypiąć freaka',
    somethingWentWrong: 'Coś poszło nie tak, spróbuj ponownie',
  },
};
